import Component from "@glimmer/component";
import { on } from "@ember/modifier";
import { hash } from "@ember/helper";
import { t } from "ember-intl";
import { not, or } from "ember-truth-helpers";
import canManage from "glesys-controlpanel/helpers/can-manage";
import modal from "glesys-controlpanel/helpers/modal";
import dateFormat from "glesys-controlpanel/helpers/date-format";
import PageContent from "glesys-controlpanel/components/page-content";
import PageContentServiceIntro from "glesys-controlpanel/components/page-content/service-intro";
import GButtonLinkTo from "glesys-controlpanel/components/g-button/link-to";
import Entity from "glesys-controlpanel/components/entity";
import EntityField from "glesys-controlpanel/components/entity/fields/field";
import EntityList from "glesys-controlpanel/components/entity-list";
import DropdownDestructiveItem from "glesys-controlpanel/components/dropdown/destructive-item";
import EmptyState from "glesys-controlpanel/components/empty-state";

export default class RemoteHandsRequestOverview extends Component {
  get remoteHandsRequests() {
    return this.args.model.remoteHandsRequests;
  }

  get colocationRacks() {
    return this.args.model.colocationRacks;
  }

  services = (remoteHandsRequest) => {
    return remoteHandsRequest.servicekeys
      ?.map((serviceKey) => {
        let cabinet = this.colocationRacks.find((colocationRack) => colocationRack.id === serviceKey)?.cabinet;

        return cabinet ? `${cabinet} (${serviceKey})` : serviceKey;
      })
      .join(", ");
  };

  shipmentCount = (remoteHandsRequest) => {
    return remoteHandsRequest.shipments.length || "—";
  };

  <template>
    <PageContent>
      <PageContentServiceIntro @title="Remote Hands">
        <div class="flex gap-2">
          {{#if (canManage)}}
            <GButtonLinkTo
              data-test-remote-hands-request-create-request
              @route="remote-hands-request.create"
              @color="blue"
            >{{t "button.create-request"}}</GButtonLinkTo>
          {{/if}}
        </div>
      </PageContentServiceIntro>
      <EntityList @items={{this.remoteHandsRequests}}>
        <:default as |remoteHandsRequest|>
          <Entity
            @route="remote-hands-request.details"
            @model={{remoteHandsRequest.id}}
            @title={{or remoteHandsRequest.title remoteHandsRequest.id}}
            @key={{if remoteHandsRequest.title remoteHandsRequest.id}}
            @workflowState={{hash
              color=remoteHandsRequest.workflowState.color
              label=(t remoteHandsRequest.workflowState.labelKey)
            }}
            @linkLabel={{t "remote-hands-requests.view-request-aria-label" key=remoteHandsRequest.id}}
            @hideActions={{not (canManage)}}
          >
            <:fields>
              <EntityField data-test-remote-hands-request-services @label={{t "label.services"}}>
                {{this.services remoteHandsRequest}}
              </EntityField>
              <EntityField data-test-remote-hands-request-execution-option @label={{t "label.execution-option"}}>
                {{t remoteHandsRequest.executionOptionLabelKey}}
              </EntityField>
              <EntityField data-test-remote-hands-request-shipments @label={{t "label.shipments"}}>
                {{this.shipmentCount remoteHandsRequest}}
              </EntityField>
              <EntityField data-test-remote-hands-request-created @label={{t "label.created"}}>
                {{dateFormat remoteHandsRequest.createdat "YYYY-MM-DD HH:mm"}}
              </EntityField>
            </:fields>
            <:actions>
              <DropdownDestructiveItem
                data-test-remote-hands-request-cancel
                disabled={{remoteHandsRequest.isNotCancelable}}
                {{on
                  "click"
                  (modal
                    "modals/confirm"
                    task=remoteHandsRequest.cancelTask
                    text=(t "remote-hands-requests.cancel.text")
                    titleText=(t "remote-hands-requests.cancel.title" remoteHandsId=remoteHandsRequest.id)
                    buttonText=(t "remote-hands-requests.cancel.button")
                  )
                }}
              >
                {{t "button.cancel"}}
              </DropdownDestructiveItem>
            </:actions>
          </Entity>
        </:default>
        <:empty>
          <EmptyState
            data-test-remote-hands-request-empty-state
            @title={{t "remote-hands-requests.empty-state.title"}}
            @description={{t "remote-hands-requests.empty-state.description"}}
          />
        </:empty>
      </EntityList>
    </PageContent>
  </template>
}
